import { render, staticRenderFns } from "./StoreOrderItemModal.vue?vue&type=template&id=00674d67&scoped=true"
import script from "./StoreOrderItemModal.vue?vue&type=script&lang=js"
export * from "./StoreOrderItemModal.vue?vue&type=script&lang=js"
import style0 from "./StoreOrderItemModal.vue?vue&type=style&index=0&id=00674d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00674d67",
  null
  
)

export default component.exports